// extracted by mini-css-extract-plugin
export default {"not-report-creator-warning-popup":"NotReportCreatorWarningPopup_not-report-creator-warning-popup__gVWHI","body":"NotReportCreatorWarningPopup_body__yqsTi"};